import './client.css'
import '@wix/design-system/styles.global.css'

import { WixDesignSystemProvider } from '@wix/design-system'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { App } from './components/App/App'

ReactDOM.render(
  <WixDesignSystemProvider features={{ newColorsBranding: true }}>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </WixDesignSystemProvider>,
  document.getElementById('root'),
)
